<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-XuanGuan`]" width="1em" height="1em" v-bind="$attrs"><path d="M3 17.5746V4.1571C3 3.61382 3.55965 3.25077 4.05574 3.47225L7.59577 5.0526C7.866 5.17324 8.04 5.44152 8.04 5.73746V19.6817C8.04 20.2635 7.40632 20.6238 6.90639 20.3262L3.36639 18.219C3.1392 18.0838 3 17.8389 3 17.5746zM15.959 17.5746V4.1571C15.959 3.61382 16.5186 3.25077 17.0147 3.47225L20.5547 5.0526C20.825 5.17324 20.999 5.44152 20.999 5.73746V19.6817C20.999 20.2635 20.3653 20.6238 19.8654 20.3262L16.3254 18.219C16.0982 18.0838 15.959 17.8389 15.959 17.5746zM14.5205 17.5746V4.1571C14.5205 3.61382 13.9608 3.25077 13.4647 3.47225L9.92469 5.0526C9.65447 5.17324 9.48047 5.44152 9.48047 5.73746V19.6817C9.48047 20.2635 10.1141 20.6238 10.6141 20.3262L14.1541 18.219C14.3813 18.0838 14.5205 17.8389 14.5205 17.5746z" stroke="#333" stroke-linecap="round"/></svg>
</template>
<script>

export default {
  name: 'IconXuanGuan',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
